import React from 'react';
import { Select } from 'antd';
import { useQuery } from 'react-query';
import { getTaskListByTaskTrigger } from 'services/workflow';

export type TaskInputProps = {
  tasktrigger: string;
};

const TaskInputByTaskTrigger = ({
  tasktrigger,
  ...otherProps
}: TaskInputProps) => {
  const { data } = useQuery(
    [tasktrigger, 'getTaskListByProccode'],
    () =>
      getTaskListByTaskTrigger({ tasktrigger: tasktrigger! }).then(
        (res) => res.list || []
      ),
    {
      staleTime: 60 * 1000,
    }
  );

  return (
    <Select {...otherProps} allowClear>
      {data?.map(({ taskid, tasklabel }: any) => (
        <Select.Option value={taskid} key={taskid}>
          {tasklabel}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TaskInputByTaskTrigger;
